import {default as ExcelFile, ExcelSheet ,ExcelColumn} from "react-data-export" 
import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';


const database=firebase.database();

class ReporteGeneralViajesEmpresa extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			viajes:[],
			empresas:[],
			vehiculos:[],
			empleados:[],
			clientes:[],
			input_disabled:'disabled',
			fecha_actual:'',
			costoD:[]
			
		}
	
	
	
		this.handleChangeDatePicker1=this.handleChangeDatePicker1.bind(this);
		this.handleChangeDatePicker2=this.handleChangeDatePicker2.bind(this);
		this.mostrarRegistrosHoy=this.mostrarRegistrosHoy.bind(this);
		
	
		
		let f=new Date();
		
		this.state.fecha_actual=f.getFullYear()+'-'+((f.getMonth()+1)>10 ? f.getMonth:'0'+(f.getMonth()+1))+'-'+(f.getDate()>10?f.getDate():'0'+f.getDate());
	
	
		this.clientesRef=database.ref().child('Clientes');
		this.empleadosRef=database.ref().child('Empleados');
		this.empresasRef=database.ref().child('Empresa');
		this.vehiculosRef=database.ref().child('Vehiculos');
		this.costosRef = database.ref().child('CentroCosto');
		this.viajesRef=database.ref().child('Viaje');
	
	}
	
	
	componentDidMount(){
		
		this.costosRef.once('value').then(this.gotCostos,this.errDataCosos);
		this.clientesRef.once('value',this.gotDataClientes,this.errDataClientes);
		
	}

	gotCostos=(data)=>{
		let Datos = [];
		const Base = data.val();
		if(Base!=null){
			const keys = Object.keys(Base);
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				Datos.push({
					key:k,
					codigo:Base[k].codigo,
					descripcion:Base[k].descripcion,
					responsable:Base[k].responsable,
					area:Base[k].area
				})                 
			}
			this.setState({costoD: Datos}); 
		}
	}
	errDataCosos=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataEmpresa=(data)=>{
		
		let newEmpresa=[]
		
		if(data.val()!==null){
			
			
			let dataEmpresas=data.val();
			let keys=Object.keys(dataEmpresas);
			
			
			for(let i=0;i<keys.length;i++){
				
				
				let k=keys[i];
				
				
				newEmpresa.push({
					key:k,
					codigo_activacion:dataEmpresas[k].codigo_activacion,
					codigo_empresa:dataEmpresas[k].codigo_empresa,
					correo:dataEmpresas[k].correo,
					estado:dataEmpresas[k].estado,
					razon_social:dataEmpresas[k].razon_social,
					representante:dataEmpresas[k].representante
					
				})
			}
			this.setState({empresas:newEmpresa})
			this.vehiculosRef.once('value',this.gotDataVehiculos,this.errDataVehiculos);
		}
		
		
		
	}
	errDataEmpresa=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataVehiculos=(data)=>{
		
		let newVehiculos=[]
		
		
		if(data.val()!==null){
			
			let dataVehiculos=data.val();
			let keys=Object.keys(dataVehiculos);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				newVehiculos.push({
					key:k,
					anio:dataVehiculos[k].anio,
					base:dataVehiculos[k].base,
					capacidad:dataVehiculos[k].capacidad,
					codigo_socio:dataVehiculos[k].codigo_socio,
					estado:dataVehiculos[k].estado,
					marca:dataVehiculos[k].marca,
					modelo:dataVehiculos[k].modelo,
					placa:dataVehiculos[k].placa,
					tipo_vehiculo:dataVehiculos[k].tipo_vehiculo
										
				})
				
				
			}
			this.setState({vehiculos:newVehiculos})
			this.viajesRef.once('value',this.gotDataViajes,this.errDataViajes);
		}
		
	}
	errDataVehiculos=(err)=>{
		
		console.log(err);
		
	}
	
	gotDataEmpleados=(data)=>{
		
		
		
		let newEmpleados=[]
		
		if(data.val()!==null){
			
			let dataEmpledos=data.val();
			let keys=Object.keys(dataEmpledos);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				newEmpleados.push({
					key:k,
					correo:dataEmpledos[k].correo,
					direccion:dataEmpledos[k].direccion,
					dui:dataEmpledos[k].dui,
					edad:dataEmpledos[k].edad,
					estado:dataEmpledos[k].estado,
					licencia:dataEmpledos[k].licencia,
					nombre:dataEmpledos[k].nombre,
					socio:dataEmpledos[k].socio,
					vehiculo:dataEmpledos[k].vehiculo,
					tipo_vehiculo:dataEmpledos[k].tipo_vehiculo,	
					foto:dataEmpledos[k].foto,
				})
				
				
				
			}
			this.setState({empleados:newEmpleados})
			this.empresasRef.once('value',this.gotDataEmpresa,this.errDataEmpresa);
			
		}
		
		
	}
	errDataEmpleados=(err)=>{
		
		
		console.log(err);
		
	}
	
	gotDataViajes=(data)=>{
		
		
		let newViajes=[]
		
		
		if(data.val()!==null){
			
			
			let dataViajes=data.val();
			let keys=Object.keys(dataViajes);
			
			
			
			for(let i=0;i<keys.length;i++){
				let k=keys[i]
				
				
				let cliente=this.state.clientes.find(cli=>cli.key==dataViajes[k].cliente);
				let empleado=this.state.empleados.find(emp=>emp.key==dataViajes[k].empleado);
				let vehiculo=[];
				let centro =[];
				let empresa=[]
				if(empleado!==undefined && cliente!== undefined)
				{
					vehiculo = this.state.vehiculos.find(vehi=>vehi.key === empleado.vehiculo)
					centro = this.state.costoD.find(centro=>centro.key === cliente.centro)

					if(dataViajes[k].bajarConductor===true && dataViajes[k].pago==='Empresa')
					{
						if(cliente.socio!=='no')
						{
								empresa = this.state.empresas.find(emp=>emp.key===cliente.socio);

								let texto = String(dataViajes[k].lugar)	;
								let valor = texto.replace("San Salvador,","")
								valor = valor.replace("de El Salvador","")
								valor = valor.replace("El Salvador","")
								valor = valor.replace("Centro Comercial","")
								valor = valor.replace(",","")

								let texto2 = String( dataViajes[k].partida)	;
								let valor2 = texto2.replace("San Salvador,","")
								valor2 = valor2.replace("de El Salvador","")
								valor2 = valor2.replace("El Salvador","")
								valor2 = valor2.replace("Centro Comercial","")
								valor2 = valor2.replace(",","")
							newViajes.push({
								key:k,
								cliente:(cliente!==undefined)?(cliente.nombre+' '+cliente.apellido):"",
								distancia:dataViajes[k].distancia,
								direccion:dataViajes[k].direccion,
								lugar:dataViajes[k].lugar,
								desde:valor2,
								combinacion:valor2+'-'+valor,
								empleado:(empleado!==undefined)?(empleado.nombre):"",
								pago:dataViajes[k].pago,
								fechaSubida:(dataViajes[k].fechaSubida!==undefined)?dataViajes[k].fechaSubida.substring(0,10):"",					
								fechaBajada:(dataViajes[k].fechaBajada!==undefined)?dataViajes[k].fechaBajada.substring(0,10):"",
								horaSubida:(dataViajes[k].fechaSubida!==undefined)?dataViajes[k].fechaSubida.substring(11,16):"",
								horaBajada:(dataViajes[k].fechaSubida!==undefined)?dataViajes[k].fechaBajada.substring(11,16):"",
								fechaReserva:dataViajes[k].fechaReserva,
								pago:dataViajes[k].pago,
								total:'$'+dataViajes[k].total,
								tipoV:(empleado!==undefined)?(empleado.tipo_vehiculo):"",
								areaDesc:(cliente!==undefined)?cliente.areaDesc:"",
								foto:(empleado!==undefined)?(empleado.foto):"",
								keyEmpleado:(empleado!==undefined)?(empleado.key):"",
								numero:1,
								detaCate:'#N/A',
								cantTrayec:1,
								personas:(cliente!==undefined)?cliente.nombre:"",
								vehiculo:(vehiculo!==undefined)?vehiculo.placa:"",
								centro:(centro!==undefined)?centro.codigo:"",
								responsable:(centro!==undefined)?centro.responsable:"",
								numero_empleado:(cliente!==undefined)?cliente.numero_empleado:"",
								empresa:(cliente==undefined) ? "" : (empresa !== undefined) ? empresa.codigo_empresa : "",
							})
						}
					}
				}
			}
			this.setState({viajes:newViajes,viajestemp:newViajes})
			
		}
		
	}
	errDataViajes=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataClientes=(data)=>{
		
		
		
		let newClientes=[]
		
		if(data.val()!==null){
			
			let dataClientes=data.val()
			let keys=Object.keys(dataClientes);
			
			
			for(let i=0;i<keys.length;i++){
				
					let k=keys[i]
					
					
					newClientes.push({
						key:k,
						nombre:dataClientes[k].nombre,
						apellido:dataClientes[k].apellido,
						areaDesc:dataClientes[k].areaDesc,
						centro:dataClientes[k].centro,
						numero_empleado:dataClientes[k].numero_empleado,
						socio:dataClientes[k].socio,
						
					})
			}
			this.setState({clientes:newClientes})
			this.empleadosRef.once('value',this.gotDataEmpleados,this.errDataEmpleados);
		}
		
	}
	errDataClientes=(err)=>{
		
		console.log(err);
		
	}
	
	
	handleChangeDatePicker1(){
		
		let fecha1=this.fecha1.value;
		
		
		this.fecha2.value="";
		
		this.setState({
			
			fecha_minima:fecha1,
			input_disabled:''
		})
		
	}
	
	handleChangeDatePicker2(){
		
		let fecha1=this.fecha1.value;
		let fecha2=this.fecha2.value;
		
		
		let f1=new Date(fecha1);
		let f2=new Date(fecha2);
		
		
		let newViajes=[]

		this.state.viajes=this.state.viajestemp;
		this.setState({
			
			viajes:this.state.viajestemp
		})
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			
			if(f1.getTime()<=(new Date(this.state.viajes[i].fechaBajada)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaBajada))  ||  f1.getTime()<=(new Date(this.state.viajes[i].fechaSubida)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaSubida)) ){
				
				
				
				newViajes.push({
					key:this.state.viajes[i].key,
					cliente:this.state.viajes[i].cliente,
					empleado:this.state.viajes[i].empleado,
					fechaReserva:this.state.viajes[i].fechaReserva,
					fechaBajada:this.state.viajes[i].fechaBajada,
					fechaSubida:this.state.viajes[i].fechaSubida,
					horaSubida:this.state.viajes[i].horaSubida,
					horaBajada:this.state.viajes[i].horaBajada,
					pago:this.state.viajes[i].pago,
					total:this.state.viajes[i].total,
					lugar:this.state.viajes[i].lugar,
					centro:this.state.viajes[i].centro,
					responsable:this.state.viajes[i].responsable,
					vehiculo:this.state.viajes[i].vehiculo,
					numero_empleado:this.state.viajes[i].nemple,
					numero:1,
					personas:this.state.viajes[i].cliente,
					desde:this.state.viajes[i].partida,
					tipoV:this.state.viajes[i].tipoV,
					foto:this.state.viajes[i].foto,
					keyEmpleado:this.state.viajes[i].keyEmpleado,
					combinacion:this.state.viajes[i].partida+'-'+this.state.viajes[i].lugar,
					detaCate:'#N/A',
					cantTrayec:1,
					areaDesc:this.state.viajes[i].areaDesc,
					empresa:this.state.viajes[i].empresa,
					
				})
				
			}
			
		}
		this.setState({
			
			viajes:newViajes
			
		})
		
		
		
		
				
	}
	
	mostrarRegistrosHoy(){
		
		
		let f1=new Date(this.state.fecha_actual);
		let f2=new Date(this.state.fecha_actual);
		
		
		let newViajes=[]

		this.state.viajes=this.state.viajestemp;
		this.setState({
			
			viajes:this.state.viajestemp
		})
		
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			
			if(f1.getTime()<=(new Date(this.state.viajes[i].fechaBajada)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaBajada))  ||  f1.getTime()<=(new Date(this.state.viajes[i].fechaSubida)).getTime()  && f2.getTime()>=(new Date(this.state.viajes[i].fechaSubida)) ){
				
				newViajes.push({
					key:this.state.viajes[i].key,
					cliente:this.state.viajes[i].cliente,
					empleado:this.state.viajes[i].empleado,
					fechaReserva:this.state.viajes[i].fechaReserva,
					fechaBajada:this.state.viajes[i].fechaBajada,
					fechaSubida:this.state.viajes[i].fechaSubida,
					horaSubida:this.state.viajes[i].horaSubida,
					horaBajada:this.state.viajes[i].horaBajada,
					pago:this.state.viajes[i].pago,
					total:this.state.viajes[i].total,
					lugar:this.state.viajes[i].lugar,
					centro:this.state.viajes[i].centro,
					responsable:this.state.viajes[i].responsable,
					vehiculo:this.state.viajes[i].vehiculo,
					numero_empleado:this.state.viajes[i].nemple,
					numero:1,
					personas:this.state.viajes[i].cliente,
					desde:this.state.viajes[i].partida,
					tipoV:this.state.viajes[i].tipoV,
					foto:this.state.viajes[i].foto,
					keyEmpleado:this.state.viajes[i].keyEmpleado,
					combinacion:this.state.viajes[i].partida+'-'+this.state.viajes[i].lugar,
					detaCate:'#N/A',
					cantTrayec:1,
					areaDesc:this.state.viajes[i].areaDesc,
					empresa:this.state.viajes[i].empresa
					
				})
				
			}
			
		}
		this.setState({
			
			viajes:newViajes
			
		})
		
		
		
	}
	
	
	render(){
		
		return(
				<div className="Rrporte container">
						<br/>
						<h1>Reporte de viajes empresas</h1>
						<br/>
						<div className="row">
							<div className="col-md-3">									
							{/*
							<ExcelFile  filename="Reporte_Viajes.xlsx" element={(<button className="btn btn-success btn-sm excel"><span className="glyphicon glyphicon-download-alt"></span> Descargar Excel </button>)}>
								<ExcelSheet data={this.state.viajes} name="Viajes">									
										<ExcelColumn label="Conductor" value="empleado" />
										<ExcelColumn label="Recibo" value=""/>
										<ExcelColumn label="Centro de costos" value="centro"/>
										<ExcelColumn label="Area de descargue" value=""/>
										<ExcelColumn label="Responsable de centro de costos" value="responsable"/>
										<ExcelColumn label="Unidad" value="vehiculo"/>
										<ExcelColumn label="Cantidad de personas por viaje" value="numero"/>
										<ExcelColumn label="Nombres (pasajeros)" value="personas"/>										
										<ExcelColumn label="Fecha subida" value="fechaSubida" />
										<ExcelColumn label="Hora subida" value="horaSubida" />
										<ExcelColumn label="Fecha Bajada" value="fechaBajada" />
										<ExcelColumn label="Hora Bajada" value="horaBajada" />
										<ExcelColumn label="Pago" value="pago" />
										<ExcelColumn label="Desde" value="desde"/>
										<ExcelColumn label="Hacia" value="lugar" />							
										<ExcelColumn label="Combinacion de rutas" value="combinacion"/>
										<ExcelColumn label="Tarifa aplicada" value="tipoV"/>
										<ExcelColumn label="Cantidad de trayectos" value="cantTrayec"/>
										<ExcelColumn label="Precio aplicado" value="total"/>
										<ExcelColumn label="Persona que solicita el servicio" value="cliente"/>
										<ExcelColumn label="Codigo de empleado" value="numero_empleado"/>
									</ExcelSheet>
						
							</ExcelFile>
							 */}
							</div>
							<div className="col-md-3 col-xs-6">	
								<div className="form-group">
									<label htmlFor=" fecha1">Fecha Inicio</label>
									<input type="date" name="fecha1" className="form-control" onChange={this.handleChangeDatePicker1}
									max={ this.state.fecha_actual} ref={input=>{this.fecha1=input}}
									/>
								</div>
							</div>
							<div className="col-md-3 col-xs-6">
								<div className="form-group">
									<label htmlFor="fecha2">Fecha Final</label>
									<input type="date" name="fecha2" className="form-control" disabled={this.state.input_disabled} 
									onChange={this.handleChangeDatePicker2}	max={this.state.fecha_actual} ref={input=>{this.fecha2=input}}
									/>
								</div>
							</div>
							<div className="col-md-3">
								<button type="button" className="btn btn-primary btn-sm" onClick={this.mostrarRegistrosHoy}>Registros de hoy</button>
							</div>
							
						</div>
							
						<BootstrapTable data={ this.state.viajes }
							 ref='table'			 
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 	<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'}  dataField='empresa' dataSort={true} >Empresa</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='empleado' dataSort={true}>Conductor</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'155'} dataField='centro' dataSort={true}>Centro de costos</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'185'} dataField='areaDesc' dataSort={true}>Area de descargue</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'300'} dataField='responsable' dataSort={true}>Responsable de centro de costos</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'155'} dataField='vehiculo' dataSort={true}>Unidad</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'255'} dataField='numero' dataSort={true}>Cantidad de personas por viaje</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'200'} dataField='personas' dataSort={true}>Nombres (pasajeros)</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='fechaSubida' dataAlign='center' dataSort={true}>Fecha Subida</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='horaSubida' dataAlign='center' dataSort={true}>Hora subida</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='fechaBajada' dataAlign='center' dataSort={true}>Fecha Bajada</TableHeaderColumn>						 						 
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='horaBajada' dataAlign='center' dataSort={true}>Hora bajada</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'} dataField='pago' dataAlign='center' dataSort={true}>Pago</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='desde' dataAlign='center' dataSort={true}>Desde</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='lugar' dataAlign='center' dataSort={true}>Hacia</TableHeaderColumn>
								
								
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'550'}  dataField='combinacion' dataAlign='center' dataSort={true}>Combinacion de rutas</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='tipoV' dataAlign='center' dataSort={true}>Tarifa aplicada</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'200'}  dataField='cantTrayec' dataAlign='center' dataSort={true}>Cantidad de trayectos</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'150'}  dataField='total' dataAlign='center' dataSort={true}>Precio aplicado</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'250'}  dataField='cliente' dataAlign='center' dataSort={true}>Persona que solicita el servicio</TableHeaderColumn>
								<TableHeaderColumn width={this.state.anchoActual>600?'0':'180'}  dataField='numero_empleado' dataAlign='center'  dataSort={true} >Codigo empleado</TableHeaderColumn>				 							 							 
						  </BootstrapTable>
									
						
						
				
				
				</div>
		
		
		)	
	}
}

export default ReporteGeneralViajesEmpresa;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteGeneralViajesEmpresa.js